import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './helpers/createBaseQuery';
import { IApplicationContext } from '../types/applicationContext';
import {
  fetchPublicB2cV2GetAvailableMultiOffers,
  TPublicB2cV2GetAvailableMultiOffersRequest,
  TPublicB2cV2GetAvailableMultiOffersResponse_1,
} from '../repositories/mortgage-broker-calculator/b2c/v2/get-available-multi-offers';
import {
  fetchPublicB2cV1SaveLead,
  TPublicB2cV1SaveLeadRequest,
  TPublicB2cV1SaveLeadResponse_1,
} from 'shared/repositories/mortgage-broker-calculator/b2c/v1/save-lead';
import {
  fetchPublicB2cV1AttachMortgageToLead,
  TPublicB2cV1AttachMortgageToLeadRequest,
  TPublicB2cV1AttachMortgageToLeadResponse_1,
} from 'shared/repositories/mortgage-broker-calculator/b2c/v1/attach-mortgage-to-lead';

export let landingApi: ReturnType<typeof createLandingApi>;
export type TLandingApiEndpoints = keyof typeof landingApi.endpoints;

export const createLandingApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'landingApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getOfferListingV2: builder.query<
        TPublicB2cV2GetAvailableMultiOffersResponse_1,
        TPublicB2cV2GetAvailableMultiOffersRequest
      >({
        query: parameters => ({
          parameters,
          fetchFunction: fetchPublicB2cV2GetAvailableMultiOffers,
          loggerInfo: {
            description: 'Получение данных для листинга',
            degradation: 'Отображение критической ошибки, листинг недоступен',
          },
        }),
      }),
      sendLead: builder.mutation<TPublicB2cV1SaveLeadResponse_1, TPublicB2cV1SaveLeadRequest>({
        query: parameters => ({
          parameters,
          fetchFunction: fetchPublicB2cV1SaveLead,
          loggerInfo: {
            description: 'Отправка данных о лиде',
            degradation: 'Отображение критической ошибки, лид не отправлен',
          },
        }),
      }),
      sendRefinLead: builder.mutation<
        TPublicB2cV1AttachMortgageToLeadResponse_1,
        TPublicB2cV1AttachMortgageToLeadRequest
      >({
        query: parameters => ({
          parameters,
          fetchFunction: fetchPublicB2cV1AttachMortgageToLead,
          loggerInfo: {
            description: 'Отправка данных о лиде (рефинансирование)',
            degradation: 'Отображение критической ошибки, данные не отправлены',
          },
        }),
      }),
    }),
  });

  landingApi = newApi;

  return newApi;
};
